import { motion } from "framer-motion";
import { SERVICES, CAPABILITIES } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function Manifesto() {
  return (
    <section
      id="services"
      className="mx-auto max-w-[1440px] px-6 py-28 md:px-12 md:py-40"
      data-testid="manifesto-section"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mb-20 grid gap-8 md:grid-cols-12"
      >
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#0033FF] md:col-span-4">
          ( 01 — Services )
        </p>
        <h2 className="font-display text-4xl font-black uppercase leading-none tracking-tight md:col-span-8 md:text-6xl">
          The Manifesto
        </h2>
      </motion.div>

      <div>
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.number}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: EASE }}
            className="group grid gap-6 border-b border-white/10 py-14 transition-colors duration-500 first:border-t hover:bg-white/[0.02] md:grid-cols-12 md:py-20"
            data-testid={`manifesto-chapter-${s.number}`}
          >
            <div className="font-mono text-6xl leading-none text-white/10 transition-colors duration-500 group-hover:text-[#0033FF]/60 md:col-span-3 md:text-8xl">
              {s.number}
            </div>
            <h3 className="font-display text-3xl font-black uppercase leading-none tracking-tight md:col-span-5 md:text-5xl">
              {s.title}
            </h3>
            <p className="max-w-md self-end text-base leading-relaxed text-[#A0A0A0] md:col-span-4">
              {s.desc}
            </p>
          </motion.article>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mt-16 flex flex-wrap gap-3"
        data-testid="capabilities-list"
      >
        {CAPABILITIES.map((c) => (
          <span
            key={c}
            className="border border-white/15 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#A0A0A0] transition-colors duration-300 hover:border-[#0033FF] hover:text-white"
          >
            {c}
          </span>
        ))}
      </motion.div>
    </section>
  );
}
